module.exports = __webpack_public_path__ + "img/Forerunner® 55.5e984301.jpg";